<av-card [backdrop]="false" class="cobrowse-launcher">
  <av-card-header
    subtitle="Send this PIN to your customer to start the session."
    (close)="close()"
  >
    @if (isCobrowse) {
    <span translate>Co-browse</span>
    } @if (isDisplayCapture) {
    <span translate>Screen Share</span>
    }
  </av-card-header>

  <av-card-body class="cobrowse-launcher-body" type="spotlight">
    @if (!ticketId) {
    <av-spinner mode="dark" size="md"></av-spinner>
    }
    <span class="ticket">{{ ticketId }}</span>
  </av-card-body>
  <av-card-footer>
    <!-- <av-card type="info">
    <av-card-body size="sm">
      Please wait for the customer to connect.
    </av-card-body>
  </av-card> -->
    @if (isChatAvailable) {
    <button
      [attr.aria-label]="'Invite customer in a co-browse session' | translate"
      avButton
      [disabled]="!ticketId || connecting"
      [loading]="connecting"
      size="block"
      color="accent"
      (click)="invite()"
      data-tid="cobrowse/send-invitation"
    >
      @if (!connecting) {
      {{ "Send invitation" | translate }}
      } @if (connecting) {
      {{ "Connecting..." | translate }}
      }
    </button>
    } @if (canGenerateChatInvitation) {
    <button
      [attr.aria-label]="'Invite customer in a co-browse session' | translate"
      avButton
      [disabled]="!ticketId || connecting"
      [loading]="connecting"
      size="block"
      color="accent"
      (click)="copyChatInvitation()"
      translate
      data-tid="cobrowse/copy-chat-invitation"
    >
      Copy invitation
    </button>
    }

    <button
      [attr.aria-label]="'Copy co-browse PIN to clipboard' | translate"
      avButton
      [disabled]="!ticketId || connecting"
      size="block"
      (click)="copy()"
      translate
      data-tid="cobrowse/copy-pin"
    >
      Copy PIN
    </button>
  </av-card-footer>
</av-card>
